import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'crt-text-truncated',
  templateUrl: 'text-truncated.component.html',
  styleUrl: 'text-truncated.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class CrtTextTruncatedComponent {
  public crop = input<number>();
  public text = input<string>();

  protected textStart = computed(() => {
    return this.text()
      ?.substring(0, this.text().length - this.crop())
      .replace(/ $/, '&nbsp;');
  });
  protected textEnd = computed(() => {
    return this.text()
      ?.substring(this.text().length - this.crop())
      .replace(/^ /, '&nbsp;');
  });
}
